/** API 페이지 응답 (page는 0부터 시작) */
export type PageResponse<T> = {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
};

export type ListQueryParams = Record<string, string | number | boolean | null | undefined>;

/** UI 1-based page → API 0-based 쿼리 문자열 */
export function buildListQuery(
  page: number,
  size: number,
  extra?: ListQueryParams
): string {
  const params = new URLSearchParams();
  params.set("page", String(Math.max(0, page - 1)));
  params.set("size", String(size));
  if (extra) {
    Object.entries(extra).forEach(([key, value]) => {
      if (value != null && value !== "") {
        params.set(key, String(value));
      }
    });
  }
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}
